export default __webpack_public_path__ + "static/media/profile-img.5687e287.svg";